import stVero from './stVero.component';
import stVeroButton from './stVeroButton.component';
import vero from './veroAuth.component';

export default angular
  .module('st.Integrations.Vero', ['st.Core', 'angular-cache'])
  .component('stVero', stVero)
  .component('stVeroButton', stVeroButton)
  .component('vero', vero)
  .service('veroService', ($http, dataService, VERO) => ({
    refer: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        VERO.API.REFER,
        { params },
        null,
        true
      )
  }))
  .constant('VERO', {
    API: {
      REFER: '/api/v1/integration/vero/refer'
    },
    INSURANCE_TYPES: [
      { id: 1, value: 'Home/Contents' },
      { id: 2, value: 'Landlord' },
      { id: 3, value: 'Motor' }
    ]
  });
